// 吃瓜糖心 —— 内容数据（单页站）
// 说明：内容聚焦热点事件的解析方法论与媒体素养，避免针对真实个体的负面指认，
// 人物与案例为示意性描述，用于演示深扒、还原、求证的内容呈现。

export interface Channel {
  id: string;
  label: string;
  desc: string;
  icon: string;
  count: string;
}

export interface TrendingItem {
  rank: number;
  title: string;
  category: string;
  heat: string;
  desc: string;
  up: boolean;
}

export interface ChainStep {
  time: string;
  title: string;
  text: string;
}

export interface Article {
  id: string;
  category: string;
  title: string;
  date: string;
  readMin: number;
  cover: string;
  lead: string;
  verdict: string;
  chain: ChainStep[];
  doubt: string;
  perspective: string;
  tags: string[];
}

export interface Faq {
  q: string;
  a: string;
}

export interface MethodStep {
  step: string;
  title: string;
  text: string;
  icon: string;
}

export const brandName = "吃瓜糖心";
export const brandSlogan = "把瓜吃透，再说话";

export const navAnchors = [
  { href: "#home", label: "首页" },
  { href: "#hot", label: "今日热榜" },
  { href: "#channels", label: "题材频道" },
  { href: "#featured", label: "深扒专题" },
  { href: "#method", label: "吃瓜方法论" },
  { href: "#about", label: "关于我们" },
  { href: "#faq", label: "常见问题" },
  { href: "#contact", label: "投稿联系" },
];

export const heroChips = [
  "深扒内幕细节",
  "真相还原",
  "背后故事",
  "线索拼接",
  "深度解析",
  "反转复盘",
];

export const channels: Channel[] = [
  { id: "showbiz", label: "娱乐圈", desc: "明星动态与作品争议的来龙去脉", icon: "ri-mic-2-line", count: "128篇" },
  { id: "society", label: "社会热点", desc: "公共议题里的情绪与事实分层", icon: "ri-government-line", count: "86篇" },
  { id: "business", label: "商业财经", desc: "企业风波背后的资金与人事逻辑", icon: "ri-line-chart-line", count: "64篇" },
  { id: "internet", label: "网络热议", desc: "刷屏话题的发酵轨迹与围观心理", icon: "ri-flashlight-line", count: "152篇" },
  { id: "tech", label: "科技圈", desc: "产品迭代与行业地震的因果还原", icon: "ri-cpu-line", count: "47篇" },
  { id: "sports", label: "体育圈", desc: "赛场外的争议、判罚与舆论角力", icon: "ri-medal-line", count: "39篇" },
];

export const trending: TrendingItem[] = [
  { rank: 1, title: "一个词引爆全网的那晚，大家都忽略了最关键的录像", category: "网络热议", heat: "热议 218万", desc: "从刷屏词到刷屏贴，真正改变走向的并非情绪，而是一段被反复剪切的原始画面。", up: true },
  { rank: 2, title: "声明只发了三行，评论区却自动补完了整部剧本", category: "娱乐圈", heat: "热议 176万", desc: "极短声明的留白越多，脑补空间越大，我们拆开这背后的公关语言。", up: true },
  { rank: 3, title: "连麦连出的大瓜：直播里那 6 秒沉默说明了一切", category: "社会热点", heat: "热议 143万", desc: "6 秒没有声音的镜头，为何被反复考古？还原一次直播事故的完整时间线。", up: true },
  { rank: 4, title: "改名、下架、清空主页：消失的内容为什么没人截图", category: "科技圈", heat: "热议 121万", desc: "数字痕迹蒸发之前，有谁在为「将来」保留证据？", up: false },
  { rank: 5, title: "同一张图被说成三个故事，谁才是「原图」", category: "网络热议", heat: "热议 98万", desc: "截图不等于真相，聊聊二次传播里被裁剪的语境。", up: true },
  { rank: 6, title: "投资方深夜发函，主角却在打游戏：商战瓜的正确吃法", category: "商业财经", heat: "热议 87万", desc: "把公司公告与个人动态放在同一条时间线上，才有完整的商业图景。", up: false },
  { rank: 7, title: "颁奖礼镜头切走的 3 分钟，成了全网二创素材", category: "娱乐圈", heat: "热议 76万", desc: "机位调度如何影响我们对「名场面」的记忆？", up: true },
  { rank: 8, title: "冷知识变热梗：一条旧采访为何突然翻红", category: "网络热议", heat: "热议 63万", desc: "翻红背后是平台算法与群体怀旧的一次共振。", up: true },
  { rank: 9, title: "饭圈打架别只吃一面之词，先分清粉籍再判断", category: "娱乐圈", heat: "热议 51万", desc: "身份站队最易失真，教你从措辞反推发言动机。", up: false },
  { rank: 10, title: "赛果被质疑的当天，裁判报告为何迟迟不发", category: "体育圈", heat: "热议 44万", desc: "规则文本与现场判罚之间，藏着舆论的信任裂缝。", up: true },
];

export const articles: Article[] = [
  {
    id: "a1",
    category: "网络热议",
    title: "一条爆料视频，如何从截图长成全网“实锤”",
    date: "2026-09-05",
    readMin: 8,
    cover: "https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20a%20single%20seed%20growing%20into%20a%20branching%20network%20of%20vine%20lines%20spreading%20across%20a%20cream%20canvas%2C%20warm%20coral%20red%20and%20fresh%20green%20accents%2C%20modern%20media%20journalism%20style%2C%20minimal%20and%20clean%2C%20soft%20shadows&width=1200&height=800&seq=chigua-art-a1&orientation=landscape",
    lead: "在「全民侦探」的时代，一条几十秒的爆料，究竟要经历几轮加工，才会被大多数围观者当成板上钉钉的实锤？我们把发酵过程切成六个节点逐一拆解。",
    verdict: "所谓“实锤”，绝大多数时候是情绪、转发与剪辑共同垒起来的共识，而非孤证本身。真正可靠的，永远是能回到源头的原始证据链。",
    chain: [
      { time: "第 1 小时", title: "源头出现", text: "一份未经证实的聊天记录或画面被首次发出，通常没有完整上下文，也几乎不打码、不出处。" },
      { time: "第 3 小时", title: "情绪放大器进场", text: "营销号与情绪化转发迅速把「我看到」升级成「大家都说」，数字开始自我复制。" },
      { time: "第 8 小时", title: "二次剪辑", text: "关键词被高亮、顺序被调整、无关画面被拼接，原始语境在此阶段基本丢失。" },
      { time: "第 24 小时", title: "对立成型", text: "立场先行的双方开始站队，事实本身退到第二排，情绪成为传播主力。" },
      { time: "第 48 小时", title: "首轮反转", text: "当事人或相关方给出另一版本，围观者开始回头寻找最初的源头素材。" },
      { time: "第 72 小时", title: "回到原始帧", text: "愿意求证的人逐帧比对，真相才真正浮出水面——它往往不如传言戏剧化。" },
    ],
    doubt: "为什么看似不利的证据，往往在仔细比对后反而站不住脚？因为传播每多一层，信息就多一分失真；而多数人看到的，恰恰是最失真的那层。",
    perspective: "与其追着「别人都在转发的那一版」跑，不如直接回到发布源头，把时间线拉直、把语境补全。慢一拍，通常更接近真。" ,
    tags: ["实锤", "二次传播", "信源追踪"],
  },
  {
    id: "a2",
    category: "娱乐圈",
    title: "“反转”从来不是终点，吃瓜为什么总在等第三集",
    date: "2026-09-03",
    readMin: 7,
    cover: "https://readdy.ai/api/search-image?query=Abstract%20editorial%20art%20of%20layered%20overlapping%20translucent%20curtains%20in%20warm%20peach%20coral%20tones%2C%20each%20layer%20revealing%20a%20fading%20silhouette%2C%20magazine%20storytelling%20visual%2C%20cream%20background%2C%20clean%20modern%20minimalist&width=1200&height=800&seq=chigua-art-a2&orientation=landscape",
    lead: "第一集说 A 错，第二集说其实 B 错，第三集又说是 C 在搅局。观众越看越累，却越看越离不开。聊聊“反转叙事”为什么总能留住吃瓜人。",
    verdict: "反转本身是一种叙事惯性：只要信息是挤牙膏式释放，舆论就永远停在「等下一集」。想不被遛，就得主动建立完整证据框架，而不是被动等导演剪辑版。",
    chain: [
      { time: "第一幕", title: "高能开场", text: "以最有冲击力、最容易点燃情绪的信息开场，天然获得最多转发，为后续反转埋下高落差。" },
      { time: "第二幕", title: "反转上位", text: "当细节补全，上一幕的“主角”被重新框定，围观者产生被骗感，愤怒转向新目标。" },
      { time: "第三幕", title: "真相落地", text: "只有回到公告、官方文书、原始画面等多源交叉，叙事才不再反复横跳。" },
      { time: "尾声", title: "反思机制", text: "成熟的吃瓜，是给每一幕都打上「存疑」标记，直到证据链闭环。" },
    ],
    doubt: "为何每次反转都会有一大批人「又被骗了」？因为大众默认剧情是线性的，而现实永远是多线并发、相互牵扯的。",
    perspective: "给情绪留 24 小时冷静期，给证据留一个交叉验证的入口。被遛的次数，取决于你有多急着下判断。",
    tags: ["反转", "叙事分析", "舆论场"],
  },
  {
    id: "a3",
    category: "社会热点",
    title: "时间线才是硬通货：一次跨平台吃瓜的拼图实录",
    date: "2026-08-28",
    readMin: 9,
    cover: "https://readdy.ai/api/search-image?query=Abstract%20editorial%20composition%20of%20fragmented%20paper%20pieces%20fitting%20together%20into%20a%20single%20picture%2C%20warm%20amber%20and%20coral%20palette%2C%20puzzle%20reconstruction%20theme%2C%20modern%20magazine%20visual%2C%20cream%20background%2C%20clean%20and%20minimal&width=1200&height=800&seq=chigua-art-a3&orientation=landscape",
    lead: "当一个话题横跨微博、短视频、问答社区与官方公告四条线，最容易犯的错就是把时间搞混。我们以一次事件为样本，演示「时间线拼图」怎么当饭吃。",
    verdict: "把散落在各平台的信息按分钟对齐，许多看似矛盾的节点会自然归位。时间线不是工具，而是深扒的基本功。",
    chain: [
      { time: "T-2 天", title: "线下初现", text: "事件最早可能源于一次未被注意到的线下细节，先在本地小范围传播。" },
      { time: "T+0", title: "首个公开信号", text: "官方或当事人首次公开发声，多数围观者的「第一天」从这里开始。" },
      { time: "T+2 小时", title: "平台分歧", text: "短视频侧重画面、问答侧重动机、热搜侧重热度，同一事件被拆成不同侧面。" },
      { time: "T+1 天", title: "补全证词", text: "更多当事人陆续发声，口径开始交叉与冲突，时间线需反复校正。" },
      { time: "T+3 天", title: "证据归档", text: "原始画面与文书被还原，此前的二手转述价值大幅下降。" },
    ],
    doubt: "不同平台说法打架，未必是有人撒谎，更可能是各自截取的时间点不同。逐条对齐时间戳，冲突常会自行消解。",
    perspective: "把「他说的」换成「他几点说的、在哪说的、和谁有关」。时间线铺开之后，瓜会自己把脉络讲清楚。",
    tags: ["时间线", "跨平台", "拼图还原"],
  },
  {
    id: "a4",
    category: "网络热议",
    title: "当“围观”变成“网暴”，理性吃瓜的边界在哪里",
    date: "2026-08-20",
    readMin: 6,
    cover: "https://readdy.ai/api/search-image?query=Abstract%20editorial%20visual%20of%20a%20large%20crowd%20of%20small%20silhouettes%20facing%20one%20single%20spotlighted%20figure%2C%20warm%20coral%20against%20deep%20cream%20tones%2C%20commentary%20on%20online%20mob%20psychology%2C%20modern%20journalism%20illustration%2C%20clean%20and%20thoughtful&width=1200&height=800&seq=chigua-art-a4&orientation=landscape",
    lead: "吃瓜的初衷是求知与乐趣，可它有时会在不知觉间滑向群体施压。这篇文章聊的是：在成为「那根稻草」之前，普通人能守住的三条底线。",
    verdict: "围观与网暴之间没有清晰门槛，唯一的缓冲垫是「证据没闭环就保留判断」。理性吃瓜不是扫兴，恰恰是让瓜田能长久热闹下去的底气。",
    chain: [
      { time: "第一层", title: "只围观不站队", text: "在双方证据都不完整时，不下「他就是坏」的结论，允许结论暂时为空。" },
      { time: "第二层", title: "只传播可溯源内容", text: "转发前确认出处与上下文，不为「据说」「听说」添柴。" },
      { time: "第三层", title: "给当事人留澄清窗口", text: "网络判案比现实更快也更易错，留出时间让另一方说话，才是公平底色。" },
      { time: "长期", title: "定期清理信息噪音", text: "把注意力从情绪争论中抽离，回到事件本身的事实增量上。" },
    ],
    doubt: "为什么人人都觉得自己只是「随口说一句」，合在一起却足以伤人？因为群体没有主语，责任被稀释，伤害却在叠加。",
    perspective: "判断成熟与否，不看站队快慢，而看下结论时手中握着多少证据。慢即是快，克制即是尊重。",
    tags: ["理性吃瓜", "边界", "媒体素养"],
  },
];

export const methodSteps: MethodStep[] = [
  { step: "01", title: "锁定信源", text: "先问「消息最先从哪来」，拒绝只有截屏没有出处的孤证，把可疑素材单独列队。", icon: "ri-focus-3-line" },
  { step: "02", title: "拉直时间线", text: "把各平台发布按分钟对齐，冲突往往来自时间点错位，而非有人撒谎。", icon: "ri-time-line" },
  { step: "03", title: "交叉验证", text: "至少找两条互相独立的信息互相印证，证据才算初步成立。", icon: "ri-shuffle-line" },
  { step: "04", title: "补全语境", text: "看完整上下文再评论，别让掐头去尾的一句话决定你的判断。", icon: "ri-chat-quote-line" },
  { step: "05", title: "留存判断", text: "证据不闭环就允许自己「不知道」，未知比仓促定罪更诚实。", icon: "ri-inbox-2-line" },
  { step: "06", title: "复盘输出", text: "真相落定后再回头看，哪些环节失真、哪些情绪误判，才是吃瓜的最大增量。", icon: "ri-history-line" },
];

export const principles: string[] = [
  "信源第一：凡是没出处的素材，一律标注「待证实」",
  "结论可留白：证据不足时，我们明确说「还没到能下结论的时候」",
  "尊重当事人：吃瓜不网暴，还原不是为了让谁社会性死亡",
  "欢迎纠错：证据链如有疏漏，评论区与投稿通道随时待命",
];

export const testimonials: { name: string; role: string; text: string }[] = [
  { name: "小林同学", role: "吃瓜三年网友", text: "以前刷到瓜只会跟着喊，现在会先翻时间线。你们让我学会把瓜「吃慢一点」。", },
  { name: "阿黎", role: "新媒体编辑", text: "每篇解析都把线索标得清清楚楚，是我写稿前必看的「查漏补缺」清单。", },
  { name: "老周", role: "理性围观派", text: "难得有不急着下结论的自媒体。看到「待证实」三个字，反而更信你们。", },
];

export const faqs: Faq[] = [
  {
    q: "吃瓜糖心每天更新哪些内容？",
    a: "我们主要更新娱乐圈、社会热点、商业财经、网络热议、科技圈与体育圈的深度解析内容，形式包含今日热榜、题材频道与深扒专题。每篇专题都会附上可追溯的时间线与信源说明，方便你顺着线索继续考证。",
  },
  {
    q: "你们的「深扒」会和营销号一样标题党吗？",
    a: "不会。我们优先保证内容可溯源：每条关键结论都尽量给出原始信源与时间节点。在证据尚未闭环时，我们会用「待证实」「存疑」标注，而不是为了流量抢先定性。",
  },
  {
    q: "看到的瓜，为什么有时会和别处说法不一样？",
    a: "不同平台通常截取事件的不同时间点与侧面，冲突往往来自信息错位而非故意矛盾。建议你把各平台发布按时间线对齐后再对比，我们的深度解析正是按这套方法整理的。",
  },
  {
    q: "我掌握了一些素材，怎么投稿给你们？",
    a: "可以在页面底部的投稿表单留下线索与联系方式，或直接通过邮箱发送给编辑部。我们会对素材做信源核验，确认可溯源后才会采纳，并在发布前与你同步。",
  },
  {
    q: "吃瓜时怎样避免被带节奏？",
    a: "记住三步：先找源头、再拉时间线、最后交叉验证。看到情绪化结论时，先问「这句话有出处吗」。理性吃瓜不是扫兴，而是让讨论更有质量的前提。",
  },
  {
    q: "内容里的截图和爆料都可信吗？",
    a: "我们会尽量呈现可核验的原始画面与官方文书，并明确区分「事实」与「观点」；无法确认的传闻一律标注来源状态，供你自行判断，绝不装作全知。",
  },
];